<template>
  <div class="inventory-form-page inventory-form-page--edit">

    <div class="inventory-form-heading">
      <div class="inventory-form-heading__icon" aria-hidden="true"><i class="fas fa-edit"></i></div>
      <div><span>Manajemen inventori</span><h1>Ubah inventori</h1><p>Perbarui identitas, klasifikasi, dan informasi aset.</p></div>
    </div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :card-class="'inventory-form-card'">
          <template
            v-slot:body
            v-if="dataLoaded"
          >
            <Form
              :form="form"
              :route="'inventories/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/inventory/InventoryForm.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {},
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('inventories/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/inventory/list')
      } else {
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inventori", route: "" },
      { title: "Daftar Inventori", route: "/inventory/list" },
      { title: "Edit" },
    ])
    // Get Data
    this.get()
  },

}

</script>
<style lang="scss" src="@/assets/sass/pages/_inventory-form-page.scss"></style>
